import React, {useEffect, useState} from 'react';
import {Navigate, Route, Routes, useLocation, useNavigate} from 'react-router-dom';

import {AdminTabsPanelView} from 'src/modules/admin/admin-tabs-panel/admin-tabs-panel.view';
import {TabCaption, TabId, TabItem} from 'src/modules/admin/admin-tabs-panel/typedefs';
import {AiAssistUsageController} from 'src/modules/admin/ai-assist-usage/ai-assist-usage.controller';
import {
    ContractsGenerationController,
} from 'src/modules/admin/contracts-generation/contracts-generation.controller';
import {EventFamiliesController} from 'src/modules/admin/event-families/event-families.controller';
import {UserRoleManagementController} from 'src/modules/admin/user-role-management/user-role-management.controller';

const tabs: TabItem[] = [
    {
        caption: TabCaption.EVENT_FAMILIES,
        tabId: TabId.EVENT_FAMILIES,
    },
    {
        caption: TabCaption.AI_ASSIST_USAGE,
        tabId: TabId.AI_ASSIST_USAGE,
    },
    {
        caption: TabCaption.USER_ROLE_MANAGEMENT,
        tabId: TabId.USER_ROLE_MANAGEMENT,
    },
    {
        caption: TabCaption.CONTRACTS_GENERATION,
        tabId: TabId.CONTRACTS_GENERATION,
    },
];

export const AdminTabsPanelController = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [activeTab, setActiveTab] = useState(TabId.AI_ASSIST_USAGE);

    useEffect(() => {
        if (location.pathname.includes(TabId.EVENT_FAMILIES)) {
            setActiveTab(TabId.EVENT_FAMILIES);
        }
        if (location.pathname.includes(TabId.AI_ASSIST_USAGE)) {
            setActiveTab(TabId.AI_ASSIST_USAGE);
        }

        if (location.pathname.includes(TabId.USER_ROLE_MANAGEMENT)) {
            setActiveTab(TabId.USER_ROLE_MANAGEMENT);
        }

        if (location.pathname.includes(TabId.CONTRACTS_GENERATION)) {
            setActiveTab(TabId.CONTRACTS_GENERATION);
        }
    }, [location]);

    const onChangeTab = (tabId: string) => {
        navigate(tabId);
    };

    return (
        <>
            <AdminTabsPanelView activeTab={activeTab} tabs={tabs} onChangeTab={onChangeTab}/>

            <Routes>
                <Route path={TabId.EVENT_FAMILIES} element={<EventFamiliesController/>}/>
                <Route path={TabId.AI_ASSIST_USAGE} element={<AiAssistUsageController/>}/>
                <Route path={TabId.USER_ROLE_MANAGEMENT} element={<UserRoleManagementController/>}/>
                <Route path={TabId.CONTRACTS_GENERATION} element={<ContractsGenerationController/>}/>

                <Route index={true} element={<Navigate to={`${TabId.EVENT_FAMILIES}`}/>}/>
                <Route path="*" element={<Navigate to="/404"/>}/>
            </Routes>
        </>
    );
};
